import React from "react";
import SelectorList from "./common/SelectorList";
import { tenses } from "../data/constants";
import { Counters } from "../data/helpers";

export type ListType = {
  onChange: (id: string) => void;
  counters: Counters;
};

const TenseList: React.FC<ListType> = ({ onChange, counters }) => {
  return (
    <>
      <h3 className="text-center">Les temps</h3>
      <SelectorList
        list={tenses}
        onChange={onChange}
        counters={counters}
        prefix="tense"
      />
    </>
  );
};

export default TenseList;
